(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('EventCustomerSectorSearch', EventCustomerSectorSearch);

    EventCustomerSectorSearch.$inject = ['$resource'];

    function EventCustomerSectorSearch($resource) {
        var resourceUrl =  'api/_search/event-customer-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
